import React from 'react';
import { graphql } from 'gatsby';
import Seo from '../../components/seo';

const PrivacyPolicy = ({ data }) => (
    <div className="container my-5 py-5">
        <h1>Privacy Policy</h1>
        <hr style={{ margin: `2rem 0` }} />
        {data.allWpPage.edges.map(({ node }) => {
            return (
                <div className="col-12" key={node.databaseId}>
                    <div dangerouslySetInnerHTML={{ __html: node.content }} />
                </div>
            );
        })}
    </div>
);

export default PrivacyPolicy;

export const pageQuery = graphql`
    query {
        allWpPage(filter: { databaseId: { eq: 10361 } }) {
            edges {
                node {
                    title
                    databaseId
                    content
                }
            }
        }
    }
`;

export const Head = ({ pageContext }) => <Seo pageContext={pageContext} />;
